import { APP_ROLE, resolveAppRole } from './roles';

export const ROUTE_PERMISSION = Object.freeze({
    HOME: 'HOME',
    APPOINTMENTS: 'APPOINTMENTS',
    DOCTORS_LIST: 'DOCTORS_LIST',
    CAREGIVERS_LIST: 'CAREGIVERS_LIST',
    DOCUMENTS: 'DOCUMENTS',
    SETTINGS: 'SETTINGS',
    MY_PROFILE: 'MY_PROFILE',
    CREATE_DOCTOR: 'CREATE_DOCTOR',
    CREATE_CAREGIVER: 'CREATE_CAREGIVER'
});

const BASE_ALLOWED_ROLES = new Set([
    APP_ROLE.BCK_ADMIN,
    APP_ROLE.ACCOUNT_ADMIN,
    APP_ROLE.CLINIC_CARE_GIVER
]);

const ROUTE_ALLOWED_ROLES = Object.freeze({
    [ROUTE_PERMISSION.HOME]: BASE_ALLOWED_ROLES,
    [ROUTE_PERMISSION.APPOINTMENTS]: BASE_ALLOWED_ROLES,
    [ROUTE_PERMISSION.DOCTORS_LIST]: BASE_ALLOWED_ROLES,
    [ROUTE_PERMISSION.CAREGIVERS_LIST]: BASE_ALLOWED_ROLES,
    [ROUTE_PERMISSION.DOCUMENTS]: BASE_ALLOWED_ROLES,
    [ROUTE_PERMISSION.SETTINGS]: new Set([APP_ROLE.ACCOUNT_ADMIN]),
    [ROUTE_PERMISSION.MY_PROFILE]: BASE_ALLOWED_ROLES,
    [ROUTE_PERMISSION.CREATE_DOCTOR]: BASE_ALLOWED_ROLES,
    [ROUTE_PERMISSION.CREATE_CAREGIVER]: BASE_ALLOWED_ROLES
});

export const canAccessRoute = (roleName, routePermission) => {
    const appRole = resolveAppRole(roleName);
    const allowedRoles = ROUTE_ALLOWED_ROLES[routePermission];

    if (!allowedRoles) {
        return true;
    }

    return allowedRoles.has(appRole);
};
